import { StorageKeys } from '../constants/storageKeys';

// Minimal stored-user shape. The full app `User` type lived in the app-only
// types barrel (`src/types`), which also re-exported @comtev-ltd/agent-client
// types. The marketing site only persists/reads the stored user for Sentry
// context (role), so it is defined locally here to keep the app types + the
// agent-client dependency out of this repo.
export interface User {
  id: string;
  email: string;
  name?: string;
  role?: string;
  account_id?: string;
  account_name?: string;
  avatar_url?: string | null;
}

export const getAccessToken = (): string | null => localStorage.getItem(StorageKeys.accessToken);

export const setAccessToken = (token: string): void => {
    localStorage.setItem(StorageKeys.accessToken, token);
};

export const clearAccessToken = (): void => {
    localStorage.removeItem(StorageKeys.accessToken);
};

export const getStoredUser = (): { user: User | null; error?: unknown } => {
    const raw = localStorage.getItem(StorageKeys.user);
    if (!raw) return { user: null };
    try {
        return { user: JSON.parse(raw) as User };
    } catch (error) {
        return { user: null, error };
    }
};

export const setStoredUser = (user: User): void => {
    localStorage.setItem(StorageKeys.user, JSON.stringify(user));
};

export const clearStoredUser = (): void => {
    localStorage.removeItem(StorageKeys.user);
};

export const clearAuthStorage = (): void => {
    clearAccessToken();
    clearStoredUser();
    localStorage.removeItem('comtev_view_mode');
};
